import { Card, Row, Col, Typography, Button, Divider } from 'antd';
import {
	FileTextOutlined,
	BarChartOutlined,
	MobileOutlined,
	DollarOutlined,
	ShoppingOutlined,
	WalletOutlined,
	ExclamationCircleOutlined,
	TeamOutlined,
} from '@ant-design/icons';
import AppLayout from '../../layouts/app.layout';
import { useNavigate } from 'react-router-dom';

const { Title, Text } = Typography;

const Reports = () => {
	const navigate = useNavigate();

	const reportCards = [
		{
			title: 'Device Report v1',
			description:
				'Financial tracking for approved devices including payment status, balances, retailer details, and overdue payment monitoring.',
			icon: <MobileOutlined className="text-2xl text-blue-500" />,
			route: '/admin/reports/device-report-v1',
			color: 'border-blue-200 hover:border-blue-400',
			bgColor: 'bg-blue-50',
		},
		{
			title: 'Sales Report',
			description: 'Comprehensive sales analytics including retailer performance, device sales, payment tracking, and revenue insights.',
			icon: <ShoppingOutlined className="text-2xl text-indigo-500" />,
			route: '/admin/reports/sales',
			color: 'border-indigo-200 hover:border-indigo-400',
			bgColor: 'bg-indigo-50',
		},
		{
			title: 'Overdue Report',
			description: 'Track overdue payments, penalty amounts, and customer payment status with detailed analytics and insights.',
			icon: <ExclamationCircleOutlined className="text-2xl text-red-500" />,
			route: '/admin/reports/overdue',
			color: 'border-red-200 hover:border-red-400',
			bgColor: 'bg-red-50',
		},
		{
			title: 'Payouts Report',
			description: 'Track retailer payouts and commissions including total payout amounts and device count metrics.',
			icon: <WalletOutlined className="text-2xl text-emerald-500" />,
			route: '/admin/reports/payouts',
			color: 'border-emerald-200 hover:border-emerald-400',
			bgColor: 'bg-emerald-50',
		},
		{
			title: 'Insurance Report',
			description: 'Streamlined device wise details for insurance companies visibility.',
			icon: <WalletOutlined className="text-2xl text-emerald-500" />,
			route: '/admin/reports/insurance',
			color: 'border-emerald-200 hover:border-emerald-400',
			bgColor: 'bg-emerald-50',
		},
		{
			title: 'Revenue Reports',
			description: 'Revenue insights, transaction trends, and sales performance metrics across all channels.',
			icon: <BarChartOutlined className="text-2xl text-green-500" />,
			route: '/admin/reports/revenue-report',
			color: 'border-green-200 hover:border-green-400',
			bgColor: 'bg-green-50',
			disabled: false,
		},
		{
			title: 'Financial Reports',
			description: 'Detailed financial statements, profit margins, and expense tracking for business insights.',
			icon: <DollarOutlined className="text-2xl text-yellow-500" />,
			route: '/admin/reports/financial',
			color: 'border-yellow-200 hover:border-yellow-400',
			bgColor: 'bg-yellow-50',
			disabled: false,
		},
		{
			title: 'Commission Report',
			description: 'Calculate agent commissions per month with defaulted and recovered device checks. 70% current month, 30% balance from previous month.',
			icon: <TeamOutlined className="text-2xl text-teal-500" />,
			route: '/admin/reports/commission',
			color: 'border-teal-200 hover:border-teal-400',
			bgColor: 'bg-teal-50',
		},
		{
			title: 'Communication Logs',
			description: 'View and analyze communication logs for better customer interactions and support.',
			icon: <FileTextOutlined className="text-2xl text-purple-500" />,
			route: '/admin/reports/system',
			color: 'border-purple-200 hover:border-purple-400',
			bgColor: 'bg-purple-50',
			disabled: true,
		},
	];

	return (
		<AppLayout
			title="Reports"
			subtitle="Generate and view comprehensive reports for business insights"
		>
			<div className="mb-6">
				<Title
					level={4}
					className="mb-2"
				>
					Available Reports
				</Title>
				<Text type="secondary">Access detailed analytics and insights to make informed business decisions</Text>
			</div>

			<Row gutter={[24, 24]}>
				{reportCards.map((report, index) => (
					<Col
						xs={24}
						sm={12}
						lg={8}
						xl={6}
						key={index}
					>
						<Card
							className={`h-full cursor-pointer shadow-sm transition-all duration-200 hover:shadow-md ${report.color} ${
								report.disabled ? 'opacity-60' : ''
							}`}
							bodyStyle={{ padding: '24px' }}
							onClick={() => !report.disabled && navigate(report.route)}
						>
							<div className={`${report.bgColor} mb-4 rounded-lg p-4 text-center`}>{report.icon}</div>

							<Title
								level={5}
								className="mb-2 text-gray-800"
							>
								{report.title}
							</Title>

							<Text
								type="secondary"
								className="mb-4 block text-sm leading-relaxed"
							>
								{report.description}
							</Text>

							<div className="mt-auto">
								<Button
									type={report.disabled ? 'default' : 'primary'}
									size="small"
									block
									disabled={report.disabled}
									onClick={(e) => {
										e.stopPropagation();
										if (!report.disabled) navigate(report.route);
									}}
								>
									{report.disabled ? 'Coming Soon' : 'View Report'}
								</Button>
							</div>
						</Card>
					</Col>
				))}
			</Row>

			<Divider className="my-8" />

			{/* <Card className="shadow-sm">
				<Title
					level={5}
					className="mb-3"
				>
					Quick Actions
				</Title>
				<div className="flex flex-wrap gap-3">
					<Button
						type="default"
						icon={<FileTextOutlined />}
					>
						Export All Reports
					</Button>
					<Button
						type="default"
						icon={<BarChartOutlined />}
					>
						Schedule Reports
					</Button>
					<Button type="default">Report Settings</Button>
				</div>
			</Card> */}
		</AppLayout>
	);
};

export default Reports;
